import { Download as DownloadIcon } from 'lucide-react';
import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';
import { AMAZON_URL } from '../../lib/constants';

const BookCover: React.FC = () => {
  const { t } = useI18n();

  return (
    <section id='book-cover' className='bg-white py-16'>
      <div className='max-w-7xl mx-auto px-8'>
        <div className='grid grid-cols-1 md:grid-cols-[1.2fr_0.8fr] gap-16 items-center'>
          {/* Columna izquierda: Texto */}
          <div className='space-y-8'>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-800'>{t.sections.bookCover.title}</h2>
            <div className='space-y-6 text-gray-600'>
              <p className='text-lg leading-relaxed'>{t.sections.bookCover.description}</p>
              <ul className='space-y-3'>
                {t.sections.bookCover.features.map((feature, index) => (
                  <li key={index} className='flex items-center gap-3'>
                    <span className='text-green-500'>✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <div className='p-6 flex flex-col items-center'>
                <a
                  href={AMAZON_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='inline-block bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-orange-600 hover:to-yellow-500 text-white font-semibold py-3 px-8 rounded-lg shadow text-center transition flex items-center justify-center gap-2 text-lg mt-8'
                >
                  <DownloadIcon className='h-5 w-5' />
                  {t.all.ctaButton}
                </a>
              </div>
            </div>
          </div>

          {/* Columna derecha: Imagen */}
          <div className='flex justify-center md:justify-end'>
            <div className='relative'>
              <img
                src='/ebook_grande.webp'
                alt='Portada del libro Testing en Angular - Guía completa de pruebas unitarias'
                width={400}
                height={600}
                loading='lazy'
                className='w-full max-w-[320px] rounded-lg shadow-xl transform hover:scale-105 transition-transform duration-300'
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookCover;
